import axios from 'axios';
import config from '../config';

const instance = axios.create({
  baseURL: config.clientApiUrl,
});

instance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isLoginRequest = error.config?.url?.includes('/auth/login');
      const isMenuRequest = error.config?.url?.includes('/menus/');
      if (!isLoginRequest && !isMenuRequest) {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        window.location.href = '/login';
      }
    }

    if (error.response?.status === 403) {
      const errorCode = error.response?.data?.code || error.response?.data?.error;
      const planLimitCodes = ['BRANCH_LIMIT_EXCEEDED', 'USER_LIMIT_EXCEEDED', 'PLAN_LIMIT_EXCEEDED'];
      if (planLimitCodes.includes(errorCode)) {
        window.dispatchEvent(new CustomEvent('plan-limit-exceeded', {
          detail: {
            reason: errorCode,
            currentPlan: sessionStorage.getItem('planTier') || 'FREE'
          }
        }));
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
